import React from 'react';

export const EmailSvg = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-776, -20)">
        <g transform="translate(776, 20)">
          <circle fill="#EA2337" cx="20" cy="20" r="20"></circle>
          <path
            d="M28,11 C29.6568542,11 31,12.3431458 31,14 L31,26 C31,27.6568542 29.6568542,29 28,29 L12,29 C10.3431458,29 9,27.6568542 9,26 L9,14 C9,12.3431458 10.3431458,11 12,11 Z M23.498,19.916 L20.7071068,22.7071068 C20.3165825,23.0976311 19.6834175,23.0976311 19.2928932,22.7071068 L16.501,19.916 L11,25.414 L11,26 C11,26.5128358 11.3860402,26.9355072 11.8833789,26.9932723 L12,27 L28,27 C28.5522847,27 29,26.5522847 29,26 L29,25.415 L23.498,19.916 Z M11,14.415 L11,22.585 L15.086,18.501 L11,14.415 Z M29,14.414 L24.914,18.5 L29,22.585 L29,14.414 Z M27.584,13 L12.415,13 L20,20.585 L27.584,13 Z"
            fill="#FAFAFA"
            fillRule="nonzero"
          />
        </g>
      </g>
    </g>
  </svg>
);
